module.exports = __webpack_public_path__ + "img/Telescopic-Crowns.8d5f5c03.jpg";